// extracted by mini-css-extract-plugin
module.exports = {"TwoEasy":"TwoEasy_TwoEasy__98n3M"};